import {
	ExchangeDiamondsRating,
	AutoclickerDiamondsRating,
} from '@/core/interfaces';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface HacksState {
	exchangeDiamondsRating: ExchangeDiamondsRating[];
	autoclickerDiamondsRating: AutoclickerDiamondsRating[];
	availableEnergyHack: number;
	countdownEnergyHack: number;
	energyTankLevel: number;
	energyTankCostLevelUp: number;
	multiTapLevel: number;
	multiTapCostLevelUp: number;
	autoclickerTimerRemainingSeconds: number;
}

const hacksSlice = createSlice({
	name: 'hacks',
	initialState: {
		exchangeDiamondsRating: [],
		autoclickerDiamondsRating: [],
		availableEnergyHack: 0,
		countdownEnergyHack: 0,
		energyTankLevel: 0,
		energyTankCostLevelUp: 0,
		multiTapLevel: 0,
		multiTapCostLevelUp: 0,
		autoclickerTimerRemainingSeconds: 0,
	} as HacksState,
	reducers: {
		setExchangeDiamondsRating: (
			state,
			action: PayloadAction<ExchangeDiamondsRating[]>
		) => {
			state.exchangeDiamondsRating = action.payload;
		},
		setAutoclickerDiamondsRating: (
			state,
			action: PayloadAction<AutoclickerDiamondsRating[]>
		) => {
			state.autoclickerDiamondsRating = action.payload;
		},
		setCountdownEnergyHack: (state, action: PayloadAction<number>) => {
			state.countdownEnergyHack = action.payload;
		},
		resetCountdownEnergyHack: (state) => {
			state.countdownEnergyHack = 3600;
		},
		decrementCountdownEnergyHack: (state) => {
			if (state.countdownEnergyHack > 0) {
				state.countdownEnergyHack -= 1;
			}
		},
		setAvailableEnergyHack: (state, action: PayloadAction<number>) => {
			state.availableEnergyHack = action.payload;
		},
		useAvailableEnergyHack: (state) => {
			state.availableEnergyHack -= 1;
		},
		setEnergyTankLevel: (state, action: PayloadAction<number>) => {
			state.energyTankLevel = action.payload;
		},
		setEnergyTankCostLevel: (state, action: PayloadAction<number>) => {
			state.energyTankCostLevelUp = action.payload;
		},
		setMultiTapLevel: (state, action: PayloadAction<number>) => {
			state.multiTapLevel = action.payload;
		},
		setMultiTapCostLevelUp: (state, action: PayloadAction<number>) => {
			state.multiTapCostLevelUp = action.payload;
		},
		setAutoclickerTimerRemainingSeconds: (
			state,
			action: PayloadAction<number>
		) => {
			state.autoclickerTimerRemainingSeconds = action.payload;
		},
		decrementCountdownAutoclicker: (state) => {
			if (state.autoclickerTimerRemainingSeconds > 0) {
				state.autoclickerTimerRemainingSeconds -= 1;
			}
		},
	},
});

const { reducer, actions } = hacksSlice;

export const {
	setExchangeDiamondsRating,
	setAutoclickerDiamondsRating,
	setCountdownEnergyHack,
	resetCountdownEnergyHack,
	decrementCountdownEnergyHack,
	setAvailableEnergyHack,
	useAvailableEnergyHack,
	setEnergyTankLevel,
	setEnergyTankCostLevel,
	setMultiTapLevel,
	setMultiTapCostLevelUp,
	setAutoclickerTimerRemainingSeconds,
	decrementCountdownAutoclicker,
} = actions;
export default reducer;
